import { useAuth0 } from "@auth0/auth0-react";
import AuthService from "Lib/API/Auth";
import FinanceSettingService from "Lib/API/FinanceSetting/FinanceSetting";
import MembersSettingService from "Lib/API/MemberSetting/MemeberSetting";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { HintField, InputField, LabelField, SelectField } from "components";
import AutoCompleteField from "components/autoCompleteField";
import CreateAbleField from "components/autoCompleteField/CreateAble";
import { useFormik } from "formik";
import { useSearch } from "hook";
import { AddNewAccountSchema } from "pages/ValidationSchema";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select";
// import CreatableSelectField from "components/autoCompleteField/CreateAble"
import Button from "components/button/Button";
import { useHistory } from "react-router";

const AddNewAccount = ({ setOpen, refresh, setRefresh,source }) => {
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [accountBillingTypes, setAccountBillingTypes] = useState();
  const [catagoryTypes, setCatagoryTypes] = useState([]);
  const [search, setSearch] = useState("");
  const [disable, setDisable] = useState(false);

  const { push } = useHistory();


  const { searchAction } = useSearch({ action: setSearch });
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const formatOptionLabel = ({ label, _id }) => {
    return (
      <div className="dropdown-container" key={_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };
  const options =
    accountBillingTypes &&
    accountBillingTypes?.map((item) => {
      return {
        label: item?.title,
        value: item?._id,
      };
    });
  const options2 =
    catagoryTypes &&
    catagoryTypes?.map((item) => {
      return {
        label: item?.title,
        value: item?._id,
      };
    });
    const accountTypeOptions = [
      {
        label: "Member",
        value: "Member",
      },
      {
        label: "Not a Member",
        value: "Not a Member",
      },
      {
        label: "Organization",
        value: "Organization",
      },
    ]

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      first_name: "",
      last_name: "",
      family_name: "",
      account_type: "",
      account_sub_type: { id: "", name: "" },
      billing_type: {
        id: "",
        name: "",
      },
      product_id: {},
      mailLabelName: "",
    },

    validationSchema: AddNewAccountSchema,
  });

  const [valueCheck, setCheckValue] = useState(false);

  useEffect(() => {
    setCheckValue(false);
  }, [formik.values]);

  // const handleButtonClicked = () => {
  //   setDisable(true);
  //    setTimeout(() => {
  //       setDisable(false);
  //     }, 5000);
  // };
  const delay = (ms) =>
    new Promise((resolve) => setTimeout(() => resolve(), ms));

  const validateSubmit = () => {
    setCheckValue(true);
    if (
      !formik?.values?.first_name ||
      !formik?.values?.last_name ||
      !formik?.values?.account_type ||
      !formik?.values?.family_name || 
      !formik?.values?.mailLabelName
    ) {
      return toastr.info("Please fill all the fields");
    }
    onSubmit();
  };

  const onSubmit = async (values) => {
    setLoading(true);
    await delay(2000);
    const token = await getAccessTokenSilently();
    const input = {
      first_name: formik.values?.first_name,
      last_name: formik.values?.last_name,
      family_name: formik.values?.family_name,
      payment: {
        account_type:
          formik.values.account_type === "Member"
            ? "member"
            : formik.values.account_type === "Not a Member"
              ? "non-member"
              : "organization",
        account_sub_type:  formik.values?.account_sub_type?.id ? {
          id: formik.values?.account_sub_type?.id,
          title: formik.values?.account_sub_type?.name,
        } : undefined,
        billing_type: formik.values?.billing_type?.id ? {
          id: formik.values?.billing_type?.id,
          title: formik.values?.billing_type?.name,
        } : undefined,
      },
      mailLabelName: formik.values?.mailLabelName,
    };

      await AuthService.postAddNewMember(input, token)
        .then((res) => {
          if(source === "members") {
            push(`/members?q=${res?._id}`);
          }
          setRefresh(!refresh);
          setLoading(false);
          setOpen(false);
        })
        .catch((err) => {
          setLoading(false);
          toastr.error("Error", err?.data?.message);
        });
    
  };

  // Get Account Billing Types List
  const fetchAccountBillingTypes = async () => {
    const token = await getAccessTokenSilently();
    await FinanceSettingService.getAccountBillingTypes(token).then((res) => {
      setAccountBillingTypes(res?.result);

      // setAccountBillingTypes(res?.result?.map((item) => item.title));
    }).catch((err) => {
      toastr.error("Error", err?.data?.message);
    });
  };
  const getTypes = async () => {
    const token = await getAccessTokenSilently();
    const type = formik.values?.account_type;
    if (type) {
      await MembersSettingService.getCatagoryListByType(
        type === "Member"
          ? "member"
          : type === "Not a Member"
            ? "not_member"
            : type === "Organization"
              ? "organization"
              : "",
        token
      ).then((res) => {
        setCatagoryTypes(res?.result);
      }).catch((err) => {
        toastr.error("Error", err?.data?.message);
      });
    }
  };
  React.useEffect(() => {
    getTypes();
  }, [formik.values?.account_type]);
  React.useEffect(() => {
    fetchAccountBillingTypes();
  }, [formik.values?.account_type]);

  const style = {
    height: "45px",
    border: "none",
    borderRadius: "5px",
    background: "#F3F6F9",
    marginBottom: "15px",
  };

  return (
    <div className="add-new-user">
      <div className="px-30 new-account">
        <p className="new-user-header mt-3">Create New Account</p>
        <InputField
          // mandatory={true}
          {...{
            formik,
            title: "First Name",
            name: "first_name",
            placeholder: "First name",
            checkValidation: false,
            mandatory: true,
            value: formik.values.first_name,
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
            if (e.key === ' ' && formik.values?.first_name === '') {
              e.preventDefault();
            }
          }}
        />

        {formik.values.first_name === "" && valueCheck && (
          <p className="text-red">Required!</p>
        )}

        <InputField
          {...{
            formik,
            title: "Last Name",
            name: "last_name",
            placeholder: "Last name",
            mandatory: true,
            checkValidation: false,
            value: formik.values.last_name,
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
            if (e.key === ' ' && formik.values?.last_name === '') {
              e.preventDefault();
            }
          }}
        />

        {formik?.values?.last_name === "" && valueCheck && (
          <p className="text-red">Required!</p>
        )}

        <InputField
          {...{
            formik,
            title: "Account name",
            name: "family_name",
            placeholder: "Account name",
            mandatory: true,
            checkValidation: true,
            value: formik.values.family_name,
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
            if (e.key === ' ' && formik.values?.family_name === '') {
              e.preventDefault();
            }
          }}
          onBlur={() => {
            if (formik.values.family_name && !formik.values.mailLabelName) {
              formik.setFieldValue("mailLabelName", formik.values.family_name);
            }
          }}
        />

        {formik?.values?.family_name === "" && valueCheck && (
          <p className="text-red">Required!</p>
        )}


        <div className="pt-1 account-type">
          <LabelField title={"Account type"}  mandatory={true}/>
          <Select
            {...{
              formik,
              name: `account_type`,
              mandatory: true,
              checkValidation: false,
            }}
            isClearable={formik.values?.account_type ?? false}
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            options={accountTypeOptions}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => {
              if(!value) {
                formik.setFieldValue("account_type", "");
              } else {
                formik.setFieldValue("account_type", value.value);
              }
              formik.setFieldValue("account_sub_type", {
                id: "",
                name: "",
              });
            }}
            value={{
              label: formik.values?.account_type,
              value: formik.values?.account_type,
            }}
            components={{ DropdownIndicator }}
          />
          {formik.values.account_type === "" && valueCheck && (
            <p className="text-red" style={{ marginBottom: "1em" }}>
              Required!
            </p>
          )}
        </div>

        <div className="pt-1 account-subtype-field">
          <LabelField title={"Account Category"} />
          <Select
            // mandatory={true}
            {...{
              formik,
              name: `account_sub_type`,
              mandatory: true,
              checkValidation: false,
            }}
            isClearable={formik.values?.account_sub_type?.id ?? false}
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            options={options2}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => {
              if(!value) {
                formik.setFieldValue(`account_sub_type`, {
                  id: "",
                  name: "",
                });
                return;
              }
              formik.setFieldValue(`account_sub_type`, {
                id: value.value,
                name: value.label,
              });
            }}
            value={{
              label: formik.values?.account_sub_type?.name,
              value: formik.values?.account_sub_type?.id,
            }}
            components={{ DropdownIndicator }}
          />
          {!formik?.values?.["account_sub_type"]?.id &&
            !formik?.values?.["billing_type"]?.name &&
            formik?.touched?.["account_sub_type"] &&
            formik?.errors?.["account_sub_type"] ? (
            <HintField error={formik?.errors?.["account_sub_type"]?.value} />
          ) : null}
        </div>

        <div className="pt-1 billing-type-field">
          <LabelField title={"Billing type"} />

          <Select
            // mandatory={true}
            {...{
              formik,
              name: `billing_type`,
              mandatory: true,
              checkValidation: false,
            }}
            isClearable={formik.values?.billing_type?.id ?? false}
            onInputChange={(text) => searchAction(text)}
            classNamePrefix="react-select"
            formatOptionLabel={formatOptionLabel}
            options={options}
            isLoading={loading}
            styles={colourStyles}
            onChange={(value) => {
              if(!value) {
                formik.setFieldValue(`billing_type`, {
                  id: "",
                  name: "",
                });
                return;
              }
              formik.setFieldValue(`billing_type`, {
                id: value.value,
                name: value.label,
              });
            }}
            value={{
              label: formik.values?.billing_type?.name,
              value: formik.values?.billing_type?.id,
            }}
            components={{ DropdownIndicator }}
          />
          {!formik?.values?.["billing_type"]?.id &&
            !formik?.values?.["billing_type"]?.name &&
            formik?.touched?.["billing_type"] &&
            formik?.errors?.["billing_type"] ? (
            <HintField error={formik?.errors?.["billing_type"]?.value} />
          ) : null}
        </div>

        <InputField
          {...{
            formik,
            title: "Mailing label name",
            name: "mailLabelName",
            placeholder: "Mailing label name",
            checkValidation: false,
            mandatory: true,
            value: formik.values.mailLabelName,
          }}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
            }
            if (e.key === ' ' && formik.values?.mailLabelName === '') {
              e.preventDefault();
            }
          }}
        />

        {formik.values.mailLabelName === "" && valueCheck && (
          <p className="text-red">Required!</p>
        )}

        <div
          className="form-group d-flex justify-content-center"
          style={{ textAlign: "center", marginBottom: "0px" }}
        >
          <Button
            className={"px-9 py-4 my-3 "}
            variant="primary"
            onClick={() => {
              validateSubmit();
            }}
            disabled={loading}
          >
            <span>Create New Account</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default AddNewAccount;
